import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { TaskActionType, TaskDetailsType } from '@/types/dashboardTypes';

export type TaskActionPayloadType = { text?: string; assigned_to_id?: string };

export const taskActionApi = (
  id: string,
  action: TaskActionType,
  payload: TaskActionPayloadType = {}
): Promise<ApiResponseType<TaskDetailsType>> => {
  return authApiService.POST(`/dashboard/tasks/${id}/${action}/`, payload);
};
